import authHeader from "./auth.header"
import { ApiError, apiFetch } from './api.js'
import constants from "./constants.js"

const HOST_URL = constants.API_URL
const fetch = apiFetch

async function request(path, options = {}) {
    const response = await fetch(`${HOST_URL}${path}`, {
        ...options,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...authHeader(),
            ...(options.headers || {})
        }
    })

    if (!response.ok) {
        let errorPayload = null
        try {
            errorPayload = await response.json()
        } catch (error) {
            errorPayload = null
        }

        if (response.status === 400) {
            throw new ApiError(400, errorPayload?.message || "La requete envoyee est invalide.")
        }

        if (response.status === 404) {
            throw new ApiError(404, errorPayload?.message || "La session demandee n'existe pas.")
        }

        throw new ApiError(response.status, "Le service IA est temporairement indisponible.")
    }

    if (response.status === 204) return null
    return response.json()
}

export async function thematicChat(sessionId, message) {
    return request("/ai/thematic-chat", {
        method: "POST",
        body: JSON.stringify({ sessionId, message })
    })
}

export async function thematicChatExpertWithThematic(sessionId, message) {
    return request("/ai/thematic-chat-expert-with-thematic", {
        method: "POST",
        body: JSON.stringify({ sessionId, message })
    })
}

export async function thematicChatExpertWithoutThematic(sessionId, message) {
    return request("/ai/thematic-chat-expert-without-thematic", {
        method: "POST",
        body: JSON.stringify({ sessionId, message })
    })
}

export async function getChatSessions() {
    return request("/ai/chat-sessions")
}

export async function getChatHistory(sessionId) {
    return request(`/ai/chat-sessions/${sessionId}/chats`)
}

export async function renameChatSession(sessionId, name) {
    return request(`/ai/chat-sessions/${sessionId}`, {
        method: "PATCH",
        body: JSON.stringify({ name })
    })
}

export async function deleteChatSession(sessionId) {
    return request(`/ai/chat-sessions/${sessionId}`, {
        method: "DELETE"
    })
}
